import { GetterTree } from 'vuex'
import { StoreInterface } from '../index'
import { SectionStateInterface } from 'src/store/section/state'

const getters: GetterTree<SectionStateInterface, StoreInterface> = {
}

export default getters
